<template>
    <div class="pt-3">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto form-inline">
                <date-picker
                    v-model="month"
                    type="month"
                    format="MM/YYYY"
                    :lang="lang"
                    placeholder="เลือกเดือน"
                    @change="getDataMonth">
                </date-picker>
                <button class="btn btn-info my-2 my-sm-0 mr-3"
                        @click="onSubmit"
                        type="button">
                    บันทึกน้ำหนัก
                </button>
                <button class="btn btn-info my-2 my-sm-0"
                        @click="onConfig"
                        type="button">
                    ตั้งค่าน้ำหนัก
                </button>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <template v-for="date in dateArray">
                        <th scope="col" colspan="4">{{ date }}</th>
                    </template>
                </tr>
                <tr>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">สินค้า</th>
                    <th scope="col">ขนาด/กล่อง</th>
                    <th scope="col">น้ำหนัก/คัน</th>
                    <template v-for="x in dateArray.length * 4">
                        <th scope="col">{{ department_column[(x - 1) % 4] }}</th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(x,sku) in list">
                    <td>{{ sku }}</td>
                    <td>{{ standardWeight[sku].name }}</td>
                    <td>{{ standardWeight[sku].sell_weight }}</td>
                    <td>{{
                            standardWeight[sku].standard_weight ? standardWeight[sku].standard_weight : 'ไม่ได้ตั้งค่า'
                        }}
                    </td>
                    <template v-for="(y,date) in x">
                        <template v-for="(z,i) in y">
                            <td :class="{'color-yellow': z != 0 && (z - standardWeight[sku].standard_weight).toFixed(1) <= -0.2 ?true:false,
                            'color-red': z != 0 && (z - standardWeight[sku].standard_weight).toFixed(1) >= 0.2 ?true:false}">
                                <template v-if="canViewSuperAdmin">
                                    <span @click="updateValue(z,i,date,sku)" :class="{'can-edit': z != 0 ? true:false}">
                                        {{ z != 0 ? z : '-' }}
                                    </span>
                                </template>
                                <template v-else>
                                    {{ z != 0 ? z : '-' }}
                                </template>
                            </td>
                        </template>
                    </template>
                </tr>
                </tbody>
            </table>
        </div>
        <!--        <div v-if="list.length > 0">-->
        <!--            <vue-pagination :pagination="dataPaginate"-->
        <!--                            @paginate="getList">-->
        <!--            </vue-pagination>-->
        <!--        </div>-->
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status" @submit="hideLoadingModal"></loading>
        </b-modal>
        <b-modal hide-header hide-footer ref="submit_modal" no-close-on-backdrop>
            <div style="text-align: center;">
                <h4>บันทึกน้ำหนัก</h4>
                <br/>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">รหัสสินค้า*</div>
                    <div class="col-sm-8">
                        <multiselect
                            v-model="form.product_id"
                            :options="optionProducts"
                            track-by="id"
                            :customLabel="LabelSkuWithName"
                            :show-labels="false"
                            placeholder="รหัสสินค้า">
                        </multiselect>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">น้ำหนักจริง*</div>
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            placeholder="น้ำหนักจริง"
                            v-model="form.weight"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">วันที่บันทึก*</div>
                    <div class="col-sm-8">
                        <date-picker v-model="form.date"
                                     class="w-100"
                                     placeholder="วันที่บันทึก"
                                     :format="changeFormat"
                                     :lang="lang">
                        </date-picker>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">กะทำงาน*</div>
                    <div class="col-sm-8">
                        <multiselect
                            v-model="form.department"
                            :options="department"
                            track-by="name"
                            label="name"
                            :show-labels="false"
                            placeholder="กะทำงาน">
                        </multiselect>
                    </div>
                </div>
                <br>
                <button @click="onConfirm()"
                        type="button"
                        :disabled="isRequired1"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="onCancel"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
                &nbsp&nbsp
                <button @click="onDeleteDaily"
                        type="button"
                        class="btn btn-outline-danger">
                    ลบ
                </button>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="config_modal" no-close-on-backdrop>
            <div style="text-align: center;">
                <h4>ตั้งค่าน้ำหนัก</h4>
                <br/>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">รหัสสินค้า*</div>
                    <div class="col-sm-8">
                        <multiselect
                            v-model="form.product_id"
                            :options="optionProducts"
                            track-by="id"
                            :customLabel="LabelSkuWithName"
                            :show-labels="false"
                            placeholder="รหัสสินค้า">
                        </multiselect>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">ขนาด/กล่อง</div>
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            placeholder="ขนาด/กล่อง"
                            v-model="form.sell_weight"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">น้ำหนัก/คัน*</div>
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            placeholder="น้ำหนัก/คัน"
                            v-model="form.standard_weight"/>
                    </div>
                </div>
                <br>
                <button @click="onConfirm()"
                        type="button"
                        :disabled="isRequired2"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="onCancel"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../Pagination";
import Multiselect from "vue-multiselect";

import {canViewSuperAdmin} from "../../util/Permissions";

import Loading from "../Utility/Loading";
import moment from "moment/moment";
import DatePicker from "vue2-datepicker";
import Button from "bootstrap-vue/es/components/button/button";

export default {
    name: "product-weight4",
    components: {
        Button,
        Loading,
        VuePagination,
        Multiselect,
        DatePicker
    },
    data() {
        return {
            msg: 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่',
            status: 1,
            list: [],
            department: [
                {id: 1, name: 'A-8'},
                {id: 2, name: 'A-2'},
                {id: 3, name: 'B-8'},
                {id: 4, name: 'B-2'},
            ],
            form: {
                id: null,
                product_id: null,
                weight: null,
                standard_weight: null,
                sell_weight: null,
                date: null,
                department: null,
                type: 4
            },
            month: null,
            // dataPaginate: {
            //     current_page: null,
            //     from: null,
            //     last_page: null,
            //     per_page: null,
            //     total: null,
            //     to: null
            // },
            changeFormat: {
                stringify: (date) => {
                    if(date && moment(date).format('MM') == '02' && moment(date).format('DD') == '29')
                          return '29/02/' + moment(date).add(543, 'y').format('YYYY');
                      return date ? moment(date).add(543, 'y').format('DD/MM/YYYY') : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            dateArray: [],
            standardWeight: [],
            department_column: ['A-8', 'A-2', 'B-8', 'B-2']
        };
    },
    created() {
        this.createDate(5);
    },
    mounted() {
        this.getList();
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            optionProducts: (state) => {
                return state.Products.product_all.filter(x => x.product_type_id == 3);
            }
        }),
        startDate() {
            return moment(this.month).startOf('month').format('YYYY-MM-DD');
        },
        endDate() {
            return moment(this.month).endOf('month').format('YYYY-MM-DD');
        },
        isRequired1() {
            if (this.form.product_id && this.form.weight && this.form.date && this.form.department)
                return false;
            return true;
        },
        isRequired2() {
            if (this.form.product_id && this.form.standard_weight)
                return false;
            return true;
        },
    },
    methods: {
        updateValue(value, index, date, sku) {
            this.form = {
                product_id: this.optionProducts.filter(x => (x.sku == sku))[0],
                weight: value,
                date: date,
                department: {id: index + 1, name: this.department_column[index]},
                type: 4
            };
            this.$refs.submit_modal.show();
        },
        getDataMonth() {
            this.showLoadingModal();
            this.month = this.month ? moment(this.month).format('YYYY-MM') : null;
            if (this.month)
                this.createDate(null, this.startDate, this.endDate);
            else
                this.createDate(5)
            this.getList();
        },
        createDate(days, start_date, end_date) {
            Date.prototype.subDays = function (days) {
                let dat = new Date(this.valueOf())
                dat.setDate(dat.getDate() - days);
                return dat;
            }

            Date.prototype.addDays = function (days) {
                let dat = new Date(this.valueOf())
                dat.setDate(dat.getDate() + days);
                return dat;
            }

            function getDates(startDate, stopDate) {
                let dateArray = new Array();
                let currentDate = stopDate;
                while (currentDate >= startDate) {
                    dateArray.push(currentDate)
                    currentDate = currentDate.subDays(1);
                }
                return dateArray;
            }

            if (days)
                this.dateArray = getDates((new Date()).subDays(days), new Date());
            else
                this.dateArray = getDates(new Date(start_date), new Date(end_date));
            for (let i = 0; i < this.dateArray.length; i++) {
                this.dateArray[i] = moment(this.dateArray[i]).format("YYYY-MM-DD");
            }
        },
        LabelSkuWithName(option) {
            if (this.optionProducts.length > 0) {
                return `${option.sku}`
            }
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getList() {
            this.showLoadingModal()
            let data = {
                month: this.month,
                type: 4
            };
            this.$store.dispatch('Standard/getWeightList', data).then(res => {
                this.list = res.data;
                this.standardWeight = res.standard_weight
                this.hideLoadingModal()
                // this.dataPaginate = {
                //     current_page: res.current_page,
                //     from: res.from,
                //     last_page: res.last_page,
                //     per_page: res.per_page,
                //     total: res.total,
                //     to: res.to
                // }
            })
        },
        onEdit(id) {
            this.$store.dispatch('Standard/showWeight', id).then(res => {
                res.data.product_id = res.data.product;
                this.form = res.data;
                this.$refs.form_modal.show();
            })
        },
        onDelete(id) {
            if (confirm('ต้องการลบรายการนี้หรือไม่'))
                this.$store.dispatch('Standard/deleteWeight', id).then(() => {
                    this.getList();
                })
        },
        onDeleteDaily() {
            if (confirm('ต้องการลบรายการนี้หรือไม่')) {
                this.form.product_id = this.form.product_id ? this.form.product_id.id : '';
                this.form.department = this.form.department ? this.form.department.name : '';
                this.form.date = this.form.date ? moment(this.form.date).format("YYYY-MM-DD") : '';
                this.$store.dispatch('Standard/deleteWeightDaily', this.form).then(() => {
                    this.getList();
                    this.onCancel();
                    this.clearModal();
                })
            }
        },
        onSubmit() {
            this.clearModal();
            this.$refs.submit_modal.show();
        },
        onConfig() {
            this.clearModal();
            this.$refs.config_modal.show();
        },
        onConfirm() {
            this.form.product_id = this.form.product_id ? this.form.product_id.id : '';
            this.form.department = this.form.department ? this.form.department.name : '';
            this.form.date = this.form.date ? moment(this.form.date).format("YYYY-MM-DD") : '';
            this.$store.dispatch('Standard/saveWeight', this.form).then(() => {
                this.getList();
                this.onCancel();
                this.clearModal();
            })
        },
        onCancel() {
            this.$refs.submit_modal.hide();
            this.$refs.config_modal.hide();
        },
        clearModal() {
            this.form = {
                id: null,
                product_id: null,
                weight: null,
                standard_weight: null,
                sell_weight: null,
                date: null,
                department: null,
                type: 4
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.color-yellow {
    background-color: yellow
}

.color-red {
    background-color: red
}

.can-edit {
    text-decoration: underline;
    cursor: pointer;
}
</style>
